// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guarantee-container {
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.guarantee-container .title-guarantee {
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
}

.guarantee-container img {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.guarantee.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".guarantee-container {\n    padding: 0 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.guarantee-container .title-guarantee {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 24px;\n}\n\n.guarantee-container img {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
